// extracted by mini-css-extract-plugin
export default {"home":"home_home__ch9Jh","content":"home_content__8yUQK","header":"home_header__HPREX","buttonBlock":"home_buttonBlock__w++6Z","white":"home_white__Dtb79","sub":"home_sub__ApvKf"};